import React from "react";

const QuantityStepper = ({ value, onChange, min = 0, max = Infinity, disabled = false }) => (
	<div className="input-group" style={{ width: "120px", flexShrink: 0, flexWrap: "nowrap" }}>
		<button
			type="button"
			className="btn btn-outline-secondary"
			style={{ flex: "0 0 36px", padding: 0 }}
			disabled={disabled || value <= min}
			onClick={() => onChange(Math.max(min, value - 1))}
		>
			−
		</button>
		{/* type="text" instead of "number": this is read-only display driven entirely by the
			+/- buttons, and a number input's native spinner arrows were eating into the
			already-narrow box, clipping the digit at some zoom levels. A firm minWidth (not 0)
			keeps this from collapsing away — flexbox+zoom rounding can shrink an unprotected
			flexible sibling to sub-pixel width. */}
		<input
			type="text"
			inputMode="numeric"
			className="form-control text-center px-1"
			style={{ flex: "1 1 auto", minWidth: "32px" }}
			value={value}
			readOnly
		/>
		<button
			type="button"
			className="btn btn-outline-secondary"
			style={{ flex: "0 0 36px", padding: 0 }}
			disabled={disabled || value >= max}
			onClick={() => onChange(Math.min(max, value + 1))}
		>
			+
		</button>
	</div>
);

export default QuantityStepper;
